import React, { useContext } from "react";
import { Button } from "reactstrap";

import { checkPermission } from "../../../common/utils/methods/commonMethods/utilityMethod";

import { RolePermissions } from "appContext";
import { PermissionContext } from "appContext";
import { pages } from "../../../common/constant";

const BuildingRow = ({
  data,
  index,
  history,
  isSaveVisible = false,
  deleteRow = () => {},
  editRow = () => {},
  cityData = [],
  stateData = [],
  countryData = [],
  regionData = [],
  businessData = [],
  setHeaderDataForFloor = () => {},
  getDisplayVal = () => {},
}) => {
  const userPermissions = RolePermissions(
    useContext(PermissionContext),
    pages["buildingmaster"]["id"],
  );

  const saveHeader = (dt) => {
    setHeaderDataForFloor({
      "Building Name": dt.buildingName,
      "Building Address": dt.address,
      City: getDisplayVal(dt.city, cityData)?.text ?? "",
      State: getDisplayVal(dt.state, stateData)?.text ?? "",
      Country: getDisplayVal(dt.country, countryData)?.text ?? "",
      Pincode: dt.pinCodeDispVal ?? "",
      "Building Status": dt.status,
      Region: getDisplayVal(dt.region, regionData)?.label ?? "",
      "Business Area":
        getDisplayVal(dt.businessArea, businessData)?.label ?? "",
      businessAreaId: dt?.businessArea,
      regionId: dt.region,
    });

    history.push(`/admin/building/${data.id}/floors`);
  };

  return (
    <tr>
      <td className="text-center align-middle p-2">
        {data?.buildingName || "-"}
      </td>

      <td className="text-center align-middle p-2">{data?.address || "-"}</td>

      <td className="text-center align-middle p-2">
        {getDisplayVal(data?.city, cityData)?.text || "-"}
      </td>

      <td className="text-center align-middle p-2">
        {getDisplayVal(data?.state, stateData)?.text || "-"}
      </td>

      <td className="text-center align-middle p-2">
        {getDisplayVal(data?.country, countryData)?.text || "-"}
      </td>

      <td className="text-center align-middle p-2">
        {data?.pinCodeDispVal || "-"}
      </td>

      <td className="text-center align-middle p-2">
        {data?.status === "ACTIVE" ? (
          <Button color="success" size="sm" disabled>
            ACTIVE
          </Button>
        ) : (
          <Button color="danger" size="sm" disabled>
            INACTIVE
          </Button>
        )}
      </td>

      <td className="text-center align-middle p-2">
        <Button
          color="primary"
          disabled={isSaveVisible}
          size="sm"
          type="button"
          className={"mx-1" + (isSaveVisible ? " btn-dark" : "")}
          onClick={() => saveHeader(data)}
        >
          Add/View Floor
        </Button>
      </td>

      <td className="text-center align-middle p-2">
        {checkPermission(userPermissions, "U") && (
          <Button
            color="info"
            size="sm"
            type="button"
            className="mx-1"
            onClick={() => editRow(index)}
          >
            <i className="fas fa-edit" />
          </Button>
        )}

        {checkPermission(userPermissions, "D") && (
          <Button
            color="info"
            size="sm"
            type="button"
            className="mx-1"
            onClick={() => deleteRow(index)}
          >
            <i className="fas fa-trash" />
          </Button>
        )}
      </td>
    </tr>
  );
};

export default BuildingRow;
